import { IStore } from '../../index'

export function isLoading(state: IStore) {
  return state.templates.templateSendModal.isLoading
}

export function isOpen(state: IStore) {
  return state.templates.templateSendModal.open
}

export function getEmail(state: IStore) {
  return state.templates.templateSendModal.email
}

export function getEvent(state: IStore) {
  return state.templates.templateSendModal.event
}
